import React, { PureComponent } from 'react';

const setPropsAsInitialValues = WrappedComponent => (
  class extends PureComponent {
    render() {
      return <WrappedComponent {...this.props} initialValues={this.props} />;
    }
  }
);

export default setPropsAsInitialValues;
